// Mint-BOD · dữ liệu đếm mẫu (11/2025 → 10/2026, tháng 10 đến 22/Oct) — chép từ code board.
export const MON = ['Nov/2025', 'Dec/2025', 'Jan/2026', 'Feb/2026', 'Mar/2026', 'Apr/2026', 'May/2026', 'Jun/2026', 'Jul/2026', 'Aug/2026', 'Sep/2026', 'Oct/2026'] as const;
export const MS = ['T11', 'T12', 'T1', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'T8', 'T9', 'T10'] as const;
export const JOB = [520, 501, 505, 324, 512, 522, 469, 423, 461, 466, 379, 501];
export const OB = [391, 365, 369, 242, 379, 406, 360, 354, 370, 384, 306, 419];
export const LS = [82, 81, 93, 56, 113, 82, 80, 52, 59, 71, 73, 81];
export const TR = [46, 54, 43, 24, 20, 34, 29, 17, 32, 11, 0, 1];
export const IB = [1, 1, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0];
export const RF = [338, 337, 318, 229, 293, 328, 287, 293, 349, 314, 254, 326];
export const CUS = [95, 91, 80, 63, 74, 74, 79, 72, 73, 74, 73, 78];
export const CAR = [44, 43, 43, 35, 42, 42, 44, 36, 42, 46, 46, 41];
export const TRF = [208, 220, 246, 169, 313, 218, 245, 332, 337, 314, 240, 224];
export const DOC = [289, 264, 392, 305, 502, 439, 497, 418, 267, 227, 256, 147];
export const CCF = [181, 158, 164, 126, 197, 177, 199, 150, 137, 132, 118, 97];
export const SCY = [39, 34, 41, 30, 40, 48, 35, 16, 33, 22, 25, 13];
export const DDL = [61, 65, 71, 58, 56, 56, 65, 71, 81, 56, 60, 37];
export const SVCJ = [203, 183, 191, 147, 206, 189, 211, 171, 164, 150, 142, 113];
export const DN = [784, 731, 773, 568, 807, 799, 714, 705, 665, 690, 553, 329];
export const JDN = [521, 494, 494, 331, 529, 527, 467, 440, 451, 465, 375, 222];
export const PT = [182, 198, 170, 129, 153, 162, 150, 176, 157, 135, 171, 112];
export const PI = [1696, 1874, 1619, 1281, 2164, 1966, 1891, 2020, 2124, 2160, 1640, 1157];
export const PC = [705, 793, 676, 466, 700, 702, 632, 636, 662, 591, 542, 326];
export const ODN = [1938, 1873, 1893, 1509, 2309, 1944, 1852, 1946, 1991, 1857, 1756, 1217];

export type Mode = 'm' | 'q' | 'y';
export const QS: readonly (readonly [string, readonly number[], string])[] = [['Q4/2025', [0, 1], 'Q4/2025 · T11–T12'], ['Q1/2026', [2, 3, 4], 'Q1/2026'], ['Q2/2026', [5, 6, 7], 'Q2/2026'], ['Q3/2026', [8, 9, 10], 'Q3/2026'], ['Q4/2026', [11], 'Q4/2026 · đến 22/Oct/2026']];
const YI = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

export function periodOf(mode: Mode, mi: number, qi: number) {
  const idx = mode === 'm' ? [mi] : mode === 'q' ? [...QS[qi]![1]] : YI;
  const pidx = mode === 'm' ? (mi > 0 ? [mi - 1] : []) : mode === 'q' ? (qi > 0 ? [...QS[qi - 1]![1]] : []) : [];
  const short = mode === 'm' ? MON[mi]! : mode === 'q' ? QS[qi]![0] : '2026';
  const label = mode === 'm' ? MON[mi] + (mi === 11 ? ' · đến 22/Oct/2026' : '') : mode === 'q' ? QS[qi]![2] : 'Năm 2026 · đến 22/Oct/2026';
  const canPrev = mode === 'm' ? mi > 0 : mode === 'q' ? qi > 0 : false;
  const canNext = mode === 'm' ? mi < 11 : mode === 'q' ? qi < 4 : false;
  return { idx, pidx, short, label, canPrev, canNext };
}

export const sum = (a: readonly number[], ix: readonly number[]): number => ix.reduce((s, i) => s + (a[i] ?? 0), 0);
export const avg = (a: readonly number[], ix: readonly number[]): number => (ix.length ? sum(a, ix) / ix.length : 0);
const th = (n: number | string): string => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
export const fi = (v: number): string => (v < 0 ? '−' : '') + th(Math.round(Math.abs(v)));
export const pc = (v: number): string => (v < 0 ? '−' : '') + Math.abs(v).toFixed(1).replace('.', ',') + '%';
/** [chữ, tốt?|null] — delta so kỳ trước. */
export function delta(cur: number, prev: number): [string, boolean | null] {
  if (!prev) return ['kỳ trước: —', null];
  const d = ((cur - prev) / Math.abs(prev)) * 100;
  return [(d >= 0 ? '+' : '−') + Math.abs(d).toFixed(1).replace('.', ',') + '% so kỳ trước', d >= 0];
}
